import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { PersonalDataAction } from "./personal-data.action";
import { SarState } from "./personal-data.model";

const INITIAL_STATE: SarState = {
	limit: {
		lastRequestCreatedOn: undefined,
		nextRequestAllowedOn: undefined,
	},
	requests: [],
	isLoading: false,
};

export const personalDataReducer = createReducer(
	INITIAL_STATE,
	on(PersonalDataAction.getRequests, (state) =>
		updateState(state, {
			isLoading: true,
		})
	),
	on(PersonalDataAction.getRequestsSuccess, (state, { payload }) =>
		updateState(state, {
			requests: payload.requests,
			limit: payload.limit,
			isLoading: false,
		})
	),
	on(PersonalDataAction.getRequestsFail, (state) =>
		updateState(state, {
			isLoading: false,
		})
	),
	on(PersonalDataAction.clear, () => INITIAL_STATE)
);
